<template>
  <v-app id="app">
    <v-navigation-drawer fixed temporary touchless class="grey lighten-4 " v-model="drawer " app>
      <v-toolbar flat class="transparent ">
        <v-list class="pt-0 " v-if="$store.getters.getUser">
          <v-list-tile avatar class="py-1 color-white" to="/profile">
            <v-list-tile-avatar>
              <img v-if="$store.getters.getUser.picture" :src="$store.getters.getUser.picture">
              <img v-else src="./assets/default_image_profile.png">
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title class="headline font-600 line-height pt-2 mt-1">{{ $store.getters.getUser.username }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-toolbar>
      <v-list dense>
        <v-list-tile to="/upload" class="mt-4 mb-2 pl-2 ">
          <v-list-tile-content>
            <v-list-tile-title class="headline font-600 color-rose line-height">Subir Productos</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <!--<v-list-tile class="pl-2 ">
          <v-list-tile-content>
            <v-list-tile-title class="title font-600 ">Mensajes</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>-->
        <v-list-tile to="/home" class="pl-2 ">
          <v-list-tile-content>
            <v-list-tile-title class="title font-600 " @click="getProductsByCategory()">Productos</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile class="pl-4 " @click="getProductsByCategory(categories[0])">
          <v-list-tile-content>
            <v-list-tile-title class="subheading ">Ropa</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile class="pl-4 " @click="getProductsByCategory(categories[1])">
          <v-list-tile-content>
            <v-list-tile-title class="subheading ">Comida</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile class="pl-4 " @click="getProductsByCategory(categories[2])">
          <v-list-tile-content>
            <v-list-tile-title class="subheading ">Juguetes</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile class="pl-4 " @click="getProductsByCategory(categories[3])">
          <v-list-tile-content>
            <v-list-tile-title class="subheading ">Libros</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile class="pl-4 " @click="getProductsByCategory(categories[4])">
          <v-list-tile-content>
            <v-list-tile-title class="subheading ">Ocio</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile class="pl-4 " @click="getProductsByCategory(categories[5])">
          <v-list-tile-content>
            <v-list-tile-title class="subheading ">Deportes</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile class="pl-4 " @click="getProductsByCategory(categories[6])">
          <v-list-tile-content>
            <v-list-tile-title class="subheading ">Otros</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-if="$store.getters.getUser && $store.getters.getUser.admin" class="pl-4 " to="/admin">
            <v-list-tile-content>
              <v-list-tile-title class="subheading ">Administración</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        <!--<v-list-tile class="pl-2 ">
          <v-list-tile-content>
            <v-list-tile-title class="title font-600 ">Ayuda</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>-->
      </v-list>
    </v-navigation-drawer>
    <v-toolbar v-if="$route.name !== 'Login'" color="white " fixed scroll-toolbar-off-screen prominent app>
      <v-btn icon v-if="$route.name === 'Product' || $route.name === 'Upload'" @click.stop="goBack " class="blue--text">
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-toolbar-side-icon v-if="$route.name === 'Home' || $route.name === 'Profile' || $route.name === 'Admin' || $route.name === '/'" @click.stop="drawer=! drawer " class="blue--text"></v-toolbar-side-icon>
      <v-spacer></v-spacer>
      <v-toolbar-title class="ml-0 mr-5 mt-2">
        <img src="./assets/icon.png" height="40px" width="150px">
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon class="blue--text" @click.stop="logOut ">
        <v-icon>power_settings_new</v-icon>
      </v-btn>
    </v-toolbar>
    <v-content>
      <router-view/>
      <v-snackbar :timeout="5000" class="hidden-sm-and-up" :bottom="true" multi-line v-model="snackbar">
        {{ textSnackBar }}
        <v-btn flat color="pink" @click.native="snackbar = false">Cerrar</v-btn>
      </v-snackbar>
      <v-snackbar :timeout="5000" :right="true" :bottom="true" class="hidden-xs-only" v-model="snackbar">
        {{ textSnackBar }}
        <v-btn flat color="pink" @click.native="snackbar = false">Cerrar</v-btn>
      </v-snackbar>
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      drawer: null,
      textSnackBar: '',
      snackbar: false,
      categories: [{
        name: 'Ropa',
        code: 107
      }, {
        name: 'Comida',
        code: 101
      },
      {
        name: 'Juguetes',
        code: 102
      },
      {
        name: 'Libros',
        code: 103
      },
      {
        name: 'Ocio',
        code: 104
      },
      {
        name: 'Deportes',
        code: 105
      },
      {
        name: 'Otros',
        code: 106
      }
      ]
    }
  },
  created () {
    this.$bus.$on('event-toast', (message) => {
      this.textSnackBar = message
      this.snackbar = true
    })
    this.$bus.$on('event-redirect', (path) => {
      this.$router.push(path)
    })
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    logOut () {
      this.$router.push('/login')
    },
    getProductsByCategory (category) {
      this.$store.state.category = category
      if (this.$route.name === 'Home') this.$bus.$emit('event-getProductsByCategory', category)
      this.drawer = false
    }
  }
}

</script>
<style>
  @import url('https://fonts.googleapis.com/css?family=Quicksand');

  .application {
    font-family: 'Quicksand', sans-serif !important;
  }

  .content {
    background-color: #ffffff !important;
    max-width: 100%;
  }

  .list__tile--link:hover {
    background-color: transparent !important;
  }

  .color-rose {
    color: #cc0088 !important;
  }

  .color-white {
    background-color: #ffffff !important;
  }

  .line-height {
    height: 100% !important;
  }

  .font-600 {
    font-weight: 600 !important;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue